import React from 'react';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';

function PlatformPieChart({ data }) {
  // Color scheme: Android (green), iOS (blue), Other (gray)
  const COLORS = ['#10B981', '#3B82F6', '#6B7280'];
  return (
    <ResponsiveContainer width="100%" height={250}>
      <PieChart>
        <Pie 
          data={data} 
          dataKey="count" 
          nameKey="platform" 
          cx="50%" cy="50%" 
          outerRadius={80} 
          innerRadius={40} 
          paddingAngle={2}
        >
          {data.map((entry, index) => (
            <Cell key={`platform-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
        <Tooltip />
        <Legend />
      </PieChart>
    </ResponsiveContainer>
  );
}

export default PlatformPieChart;

